import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=5858a3f6&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=5858a3f6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5858a3f6",
  null
  
)

/* custom blocks */
import block0 from "./ProgressBar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports